// extracted by mini-css-extract-plugin
module.exports = {"help":"helpComponent_help__2rZZ9","message_box":"helpComponent_message_box__3n6Da","message":"helpComponent_message__3P42J","block":"helpComponent_block__3u-jD"};